module.exports = __webpack_public_path__ + "static/img/test.e793e3c5.png";